import React from 'react';
import { Tooltip, Button, Icon } from 'antd';
import { FaRegFileAlt } from 'react-icons/fa';
import cn from 'classnames';
import styles from './Btn.module.scss';

const Btn = ({ tooltipProps = {}, className, loading, ...props }) => {
  return (
    <Tooltip
      placement="bottom"
      {...tooltipProps}
    >
      <Button
        {...props}
        className={cn(styles.root, className)}
      >
        {loading ? <Icon type="loading" /> : <Icon component={FaRegFileAlt} />}
      </Button>
    </Tooltip>
  );
};

export default Btn;
